import { getClosedWidgetDeletedComponents } from '../widgetDeletedComponents/closedWidgetDeletedComponents';

const expandComponent = async (editorSDK: any, componentRef: any) =>
  editorSDK.document.components.refComponents.expandReferredComponent('token', {
    componentRef,
  });

export const addComponentToClosedWidget = async (
  editorSDK: any,
  widgetRef: any,
  role: any,
) => {
  const collapsedComponents = await getClosedWidgetDeletedComponents(
    editorSDK,
    widgetRef,
  );
  const { componentRef } = collapsedComponents.find(
    (component: any) => component.role === role,
  );
  await expandComponent(editorSDK, componentRef);
};

export const addAllComponentsToClosedWidget = async (
  editorSDK: any,
  widgetRef: any,
) => {
  const collapsedComponents = await getClosedWidgetDeletedComponents(
    editorSDK,
    widgetRef,
  );
  await Promise.all(
    collapsedComponents.map(({ componentRef }: any) =>
      expandComponent(editorSDK, componentRef),
    ),
  );
};
